import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { testimonials } from '../../mocks/testimonials';

export default function ReviewsPage() {
  return (
    <div className="min-w-[1024px]">
      <Navbar />
      <main>
        <section className="bg-dark pt-44 pb-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-px bg-gold" />
              <span className="text-gold text-xs font-semibold uppercase tracking-[0.25em]">Client Stories</span>
              <span className="w-8 h-px bg-gold" />
            </div>
            <h1 className="font-serif text-6xl font-bold text-white mb-5">Customer Reviews</h1>
            <div className="flex items-center justify-center gap-2 mb-3">
              {[...Array(5)].map((_, i) => <i key={i} className="ri-star-fill text-gold text-2xl" />)}
            </div>
            <p className="text-white font-serif text-xl font-bold mb-2">5.0 · Exceptional</p>
            <p className="text-white/40">Based on 300+ verified reviews</p>
          </div>
        </section>

        <section className="py-24 bg-cream-mid">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {[...testimonials, ...testimonials].slice(0, 9).map((t, i) => (
                <div
                  key={`${t.id}-${i}`}
                  style={{ marginTop: i % 3 === 1 ? '24px' : '0' }}
                  className="bg-white rounded-2xl p-8 border border-cream-dark"
                >
                  <div className="flex gap-1 mb-5">
                    {[...Array(t.rating)].map((_, j) => <i key={j} className="ri-star-fill text-gold text-sm" />)}
                  </div>
                  <p className="text-dark/70 text-sm leading-relaxed mb-6 italic">"{t.text}"</p>
                  <div className="flex items-center gap-3 border-t border-cream-dark pt-5">
                    <div className="w-10 h-10 bg-gold/10 border border-gold/20 rounded-full flex items-center justify-center font-serif font-bold text-gold flex-shrink-0">
                      {t.name.charAt(0)}
                    </div>
                    <div>
                      <div className="font-bold text-dark text-sm">{t.name}</div>
                      <div className="text-dark/40 text-xs">{t.project}</div>
                      <div className="text-dark/30 text-xs">{t.date}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-gold rounded-2xl p-12 text-center">
              <h2 className="font-serif text-3xl font-bold text-white mb-4">Ready to Create Your Dream Home?</h2>
              <p className="text-white/80 mb-8">Join thousands of satisfied clients who've transformed their spaces with Eclectic Home.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/showroom" className="bg-white text-gold px-8 py-4 rounded font-bold text-sm uppercase tracking-wider cursor-pointer whitespace-nowrap hover:bg-cream-DEFAULT transition-colors">
                  Visit Our Showroom
                </Link>
                <Link to="/contact" className="border-2 border-white text-white px-8 py-4 rounded font-bold text-sm uppercase tracking-wider cursor-pointer whitespace-nowrap hover:bg-white/10 transition-colors">
                  Book Consultation
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
